import { Component, EventEmitter, Output } from '@angular/core';
import { RootScopeDeclare } from 'src/app/core/rootscope-declare';
import { CommonUtil } from '../../../core/Utils/common-util';

@Component({
  selector: 'app-facility-connect-session-expiry-modal',
  templateUrl: './facility-connect-session-expiry-modal.component.html',
  styleUrls: ['./facility-connect-session-expiry-modal.component.scss'],
})
export class FacilityConnectSessionExpiryModalComponent {
  public rootScopeData: RootScopeDeclare;
  public fcSessionExpiryModalTitle = 'Session Expires Soon';
  public fcSessionExpiryModalDescription =
    'Your session is about to expire. If you wish to remain logged in, please click the “Refresh” button below.';
  public fcSessionExpiryRefresh = 'Refresh';
  @Output() onClose: EventEmitter<any> = new EventEmitter();
  @Output() onRefresh: EventEmitter<any> = new EventEmitter();
  constructor(public commonUtil: CommonUtil) {}

  ngOnInit() {
    this.rootScopeData = this.commonUtil.rootScopeData;
    /* Below is the translation implementation for future.*/
    this.fcSessionExpiryModalTitle = this.commonUtil.translateText('FC.CONNECT.SESSION.EXPIRY.MODAL.TITLE');
    this.fcSessionExpiryModalDescription = this.commonUtil.translateText('FC.CONNECT.SESSION.EXPIRY.MODAL.DESCRIPTION');
    this.fcSessionExpiryRefresh = this.commonUtil.translateText('REFRESH');
  }

  close() {
    this.onClose.emit();
  }

  refresh() {
    this.onRefresh.emit();
  }
}
